'use strict';

// Numatytoji riba (m), jei iškvietime neperduota distance_max iš nustatymų.
export const GAS_DISTANCE_THRESHOLD = 150;

/**
 * Gryna preliminarios dujų įvedimo kainos logika (be Angular / jQuery).
 *
 * Formulė (ESOEW4-1370, FR-3): pirmas metras – fiksuotas tarifas, toliau –
 * tarifas už metrą. 0 ≤ A ≤ 1 skaičiuojama supaprastintai (FR-3.1).
 * PASTABA: formulė tvirtinama pagal specifikaciją (ESOEW4-1370 / 1464).
 *
 * @param {number} distance metrai (jau parseFloat'inta, kablelis -> taškas)
 * @param {{rateFirstMeter:number, ratePerMeter:number, vatPercent:number}} rates
 * @param {number} [distanceMax] riba, virš kurios grąžinama 'warning' (default GAS_DISTANCE_THRESHOLD)
 * @returns {{state:'error'}
 *           |{state:'warning'}
 *           |{state:'result', priceWithoutVat:number, priceWithVat:number}}
 */
export function computeGasConnection(distance, rates, distanceMax) {
	var threshold = (typeof distanceMax === 'number' && !isNaN(distanceMax))
		? distanceMax
		: GAS_DISTANCE_THRESHOLD;

	if (typeof distance !== 'number' || isNaN(distance) || distance < 0) {
		return { state: 'error' };
	}
	if (distance > threshold) {
		return { state: 'warning' };
	}

	var priceWithoutVat;
	if (distance <= 1) {
		// FR-3.1: supaprastinta formulė atstumui 0 ≤ A ≤ 1 (įskaitant A=1)
		priceWithoutVat = rates.rateFirstMeter;
	} else {
		// FR-3: pilna formulė 1 < A ≤ riba
		priceWithoutVat = rates.rateFirstMeter + rates.ratePerMeter * (distance - 1);
	}
	var priceWithVat = priceWithoutVat * (1 + (rates.vatPercent * 0.01));

	return {
		state: 'result',
		priceWithoutVat: priceWithoutVat,
		priceWithVat: priceWithVat
	};
}
